import React from "react";

import { useFieldArray, useFormContext } from "react-hook-form";
import { GiCancel } from "react-icons/gi";
import ProcessForm from "./ProcessForm";

interface ItemFormProps {
  index: number;
}

const ItemForm = ({ index }: ItemFormProps) => {
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: `items.${index}.processes`,
  });

  const handleAppendNewProcess = () => {
    append({
      process_id: 0,
      unit_id: 0,
      rate: null,
      qty: null,
      weight: null,
      design: null,
    });
  };

  return (
    <div className="grid">
      {fields.map((process, processIndex) => (
        <div className="mt-6" key={processIndex}>
          <h2 className="relative w-full text-2xl underline text-primary-1 font-bold mb-4">
            પ્રોસેસ - {processIndex + 1}
            {processIndex > 0 && (
              <GiCancel
                onClick={() => remove(processIndex)}
                className="absolute z-10 shadow bg-white top-1 right-1 text-3xl text-primary-1 border-2 border-primary-1 p-1 rounded-full"
              />
            )}
          </h2>

          <ProcessForm index={index} processIndex={processIndex} />
        </div>
      ))}

      <button
        className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
        type="button"
        onClick={handleAppendNewProcess}
      >
        પ્રોસેસ ઉમેરો
      </button>
    </div>
  );
};
export default ItemForm;
